import { useTranslation } from 'react-i18next';
import ChangePasswordForm from '../../components/forms/changePasswordForm';
import { LoginStore } from '../../stores/LoginStore';

type Props = {
  store: LoginStore
}
const ChangePassword = ({store}: Props) => {
  const { t } = useTranslation('registration');
  return (
    <div className="wrap">
      <div className="container">
        <div className="main">
          <div className="mb-4">
            <p className="pStyle">{t('changePasswordText')}</p>
          </div>
          <div className="grid">
              <ChangePasswordForm t={t} store={store} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
